import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "is-favourite",
  "use": "is-favourite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"is-favourite\"><circle cx=\"12\" cy=\"12\" r=\"11\" stroke=\"#702F73\" stroke-width=\"2\" /><path d=\"M12 6l1.854 3.95 4.146.637-3 3.072.708 4.341L12 15.95 8.292 18 9 13.66l-3-3.073 4.146-.637L12 6z\" fill=\"#702F73\" stroke=\"#702F73\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/is-favourite.svg
// module id = 457
// module chunks = 0